import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import {
  FinalDocumentChecklist,
  FinalDocumentationCompletion,
  FinalDocumentationRow,
} from '../types/finalDocumentation';

export const getFinalDocumentChecklist = async (
  studentId: number,
): Promise<FinalDocumentChecklist> => {
  const { data } = await apiClient.get(`/students/${studentId}/final-documentation-checklist`);
  return data.data;
};

/** Marks a conditional item not applicable (or applicable again); returns
 * the whole updated checklist. Items are otherwise completed by approving
 * their uploaded document. */
export const setFinalDocumentNotApplicable = async (
  studentId: number,
  itemKey: string,
  value: boolean,
): Promise<FinalDocumentChecklist> => {
  const { data } = await apiClient.patch(`/students/${studentId}/final-documentation-checklist`, {
    itemKey,
    field: 'notApplicable',
    value,
  });
  return data.data;
};

export const listFinalDocumentation = async (params: {
  page: number;
  pageSize: number;
  search?: string;
  branchId?: number;
  completion?: FinalDocumentationCompletion;
}): Promise<PaginatedResponse<FinalDocumentationRow>> => {
  const { data } = await apiClient.get('/ready-to-fly/final-documentation', { params });
  return data;
};
